<script>
import axios from 'axios';
import AS from '@/services/AuthenticationService';

export default {
  fetchTechnicalParameters() {
    return axios.get('technical_parameters', AS.getDefaultHeaders());
  },
  fetchTechnicalParameter(typologyId) {
    return axios.get(`tipologias/${typologyId}/parametros-tecnicos`, AS.getDefaultHeaders());
  },
  createTechnicalParameter(technicalParameterParams) {
    return axios.post('technical_parameters', technicalParameterParams, AS.getDefaultHeaders());
  },
  addTechnicalParameterToTypology(typologyId, technicalParameterParams) {
    return axios.post(`/tipologias/${typologyId}/add_technical_parameter`,
      technicalParameterParams,
      AS.getDefaultHeaders());
  },
  removeTechnicalParameter(typologyId, technicalParameterId) {
    return axios.delete(`/tipologias/${typologyId}/remove_technical_parameter/${technicalParameterId}`,
      AS.getDefaultHeaders());
  },
};
</script>

